module.exports = __webpack_public_path__ + "static/media/getting-support-large@3x.e65e3b6a.png";